import React,{useContext} from 'react'
import notesContext from '../context/notes/notesContext'

const NotesItem = (props) => {
  const context= useContext(notesContext);
  const{deleteNote,editNote}=context
    const {note,updateNote,showAlert}=props; 
     // yaha pe destructuring ka use krke props me se note nikala
    
  return (
           
      <div className="col-md-3 " >
          <div className='card my-3 shadow-lg  ' style={{backgroundColor:"#112240"}}>
            <div className='card-header' style={{color:'#BFDBFE',fontSize:"20px"}}>{note.title}</div>
      <div className="card-body  " style={{height:'250px', overflowY:'auto'}}>
    <p className="card-text" style={{color:'white'}}>{note.description}</p>

  </div>
  <div className='card-body d-flex align-items-center'>
    
  <i className="fa fa-trash-alt mx-2" onClick={()=>{deleteNote(note._id);props.showAlert("Notes deleted successfully","success");}}></i>
  <i className="fa fa-pencil mx-2" onClick={()=>{updateNote(note)}}></i>
  <span className=' border text-truncate p-1 px-2  rounded-pill'>{note.tag}</span>
  </div>
</div>
</div>
  )
}

export default NotesItem